import actions from './actions'

export default function CompanyAddresssReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_COMPANYADDRESS:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_COMPANYADDRESS:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_COMPANYADDRESS:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_COMPANYADDRESS:
      return {
        ...state,
        editing: { companyAddressID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_COMPANYADDRESS_RECIEVED ||
      actions.UPDATE_COMPANYADDRESS_RECIEVED ||
      actions.DELETE_COMPANYADDRESS_RECIEVED:
      return {
        ...state,
        editing: { companyAddressID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
